import { useState } from 'react';
import { Modal } from '../../../components/Common';
import TransferOwnershipModal from '../../../components/modalContent/TransferOwnership';
import { useTranslation } from '../../../hooks/useTranslation';
import { Button } from '../../../components/Common';

const TransferOwnership = () => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const { t } = useTranslation();

    const openModal = () => setIsModalVisible(true);
    const closeModal = () => setIsModalVisible(false);
    return (
        <div className="transfer-ownership-container">
            <div className="transfer-ownership-content">
                <h3 className="transfer-ownership-content__title">{t('settings.transferOwnershipTitle')}</h3>
                <p className="paragraph-4">{t('settings.transferOwnershipTextMessage')}</p>
                <p className="paragraph-4">{t('settings.transferOwnershipTextMessage2')}</p>
            </div>
            <div>
                <Button
                    variant="danger"
                    text={t('settings.transferOwnershipTitle')}
                    className="transfer-ownership-container__button"
                    onClick={openModal}
                />
            </div>
            <Modal isVisible={isModalVisible} closeModal={closeModal}>
                <TransferOwnershipModal isVisible={isModalVisible} closeModal={closeModal}></TransferOwnershipModal>
            </Modal>
        </div>
    );
};

export default TransferOwnership;
